// extracted by mini-css-extract-plugin
export default {"backButton":"back-button_backButton__3Yxb3","icon":"back-button_icon__MZqCO"};